import { NgModule } from '@angular/core';
import { MsListboxComponent } from './ms-listbox.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';
import { MsInputTextModule } from '../ms-input-text/ms-input-text.module';

@NgModule({
	declarations: [MsListboxComponent],
	imports: [SharedLibsModule, MsButtonModule, MsInputTextModule],
	exports: [MsListboxComponent],
	providers: [],
})
export class MsListboxModule {}
